"use client";

import { Container, Row, Col } from "react-bootstrap";
import Image from "next/image";
import styles from "./WhatYouGetSection.module.css";

import BuildBetter from "@/app/assets/buildb.svg";
import { FiArrowUpRight } from "react-icons/fi";

import Wyg1 from "@/app/assets/wyg1.svg";
import Wyg2 from "@/app/assets/wyg2.svg";
import Wyg3 from "@/app/assets/wyg3.svg";
import Wyg4 from "@/app/assets/wyg4.svg";
import Wyg5 from "@/app/assets/wyg5.svg";
import Wyg6 from "@/app/assets/wyg6.svg";

export default function WhatYouGetSection() {
  const cards = [
    {
      icon: Wyg1,
      title: "24/7 Support",
      text: "Our expert team is always available to solve issues quickly and keep things running."
    },
    {
      icon: Wyg2,
      title: "Moneyback Guarantee",
      text: "Try us risk-free for 14 days Not satisfied? Get a full refund—no questions asked."
    },
    {
      icon: Wyg3,
      title: "Various Payment Methods",
      text: "Choose from multiple secure payment options tailored for your convenience."
    },
    {
      icon: Wyg4,
      title: "SLA Uptime 99,60%",
      text: "Enjoy reliable uptime backed by our SLA, so your site stays accessible when it matters most."
    },
    {
      icon: Wyg5,
      title: "Personal Account Manager",
      text: "Get a dedicated manager who understands your goals and supports you along the way."
    },
    {
      icon: Wyg6,
      title: "Certified By The Best",
      text: "Trusted by industry leaders and backed by top-tier certifications for performance and security."
    }
  ];

  return (
    <section className={styles.section}>
      <Container>

        {/* Header */}
        <div className={styles.headerWhat}>
          <div className={styles.leftBlockWhat}>
            <span className={styles.iconWhat}>
              <Image src={BuildBetter} width={40} height={40} alt="..." />
            </span>
            <span className={styles.titleWhat}>Build Better</span>
          </div>
        </div>

        {/* Top Text — Now Responsive */}
        <Row className="align-items-center mb-5">
          <Col xs={12} md={6} lg={5} className="mb-3 mb-md-0">
            <p className={styles.subText}>
              No matter what project you&apos;re working<br /> 
              on, we&apos;ve got you covered with the<br /> 
              best wireframe kits for any platform.
            </p>
          </Col>

          <Col xs={12} md={6} lg={7} className="text-md-end text-start">
            <h2 className={styles.mainHeading}>What you get</h2>
          </Col>
        </Row>

        {/* Cards */}
        <Row className="gy-4">
          {cards.map((item, index) => (
            <Col lg={6} md={6} xs={12} key={index}>
             <div className={`${styles.cardRow} d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center`}>


                {/* Left Group */}
                <div className={`${styles.leftGroup} d-flex align-items-start gap-3 flex-grow-1`}>
                  <span className={styles.icon}>
                    <Image src={item.icon} width={28} height={28} alt={item.title} />
                  </span>

                  <div className={styles.textGroup}>
                    <h4>{item.title}</h4>
                    <p>{item.text}</p>
                  </div>
                </div>

                {/* Button — Moves Down on Mobile */}
                <div className="mt-3 mt-sm-0">
                  <button className={styles.signupBtn}>
                    Sign up <FiArrowUpRight className={styles.arrowIcon} />
                  </button>
                </div>

              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
}
